export default "__VITE_PUBLIC_ASSET__dcbe079a__"